import React from 'react';
import { motion } from '../lib/motionShim';
/** Feature chips that stagger in one by one as they enter view. */
const Chips = ({ items, className = 'mt-8' }) => (
  <motion.ul
    className={`flex flex-wrap gap-2 ${className}`}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: '-60px' }}
    variants={{ hidden: {}, show: { transition: { staggerChildren: 0.07 } } }}
  >
    {items.map((c) => (
      <motion.li
        key={c}
        variants={{
          hidden: { opacity: 0, y: 10 },
          show: { opacity: 1, y: 0, transition: { duration: 0.45, ease: [0.16, 1, 0.3, 1] } },
        }}
        className="rounded-full border border-ston-border bg-white/[0.03] px-3.5 py-1.5 text-[12.5px] text-ston-text-secondary"
      >
        {c}
      </motion.li>
    ))}
  </motion.ul>
);

export default Chips;
